import RegistroActividadPage from "../pages/RegistroActividadPage";

const routes = [
  {
    name: "RegistroActividadPage",
    path: "/registro-actividades",
    component: RegistroActividadPage,
    meta: {
      requiresAuth: true,
      permission: "REGISTRO_ACTIVIDAD_SHOW",
    },
  },
];

export default routes;
